import { render, staticRenderFns } from "./DetalhesParticipantesContrato.vue?vue&type=template&id=fe1d6564&scoped=true"
import script from "./DetalhesParticipantesContrato.vue?vue&type=script&lang=ts"
export * from "./DetalhesParticipantesContrato.vue?vue&type=script&lang=ts"
import style1 from "./DetalhesParticipantesContrato.vue?vue&type=style&index=1&id=fe1d6564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1d6564",
  null
  
)

export default component.exports